import { GlobalStyles } from '@mui/joy';

/** Shared Joy surfaces: quiet backgrounds, readable content and visible focus. */
export function ApplicationStyles() {
  return <GlobalStyles styles={(theme) => ({
    ':root, [data-joy-color-scheme="light"]': { '--brand-text': '#5d0fce' },
    '[data-joy-color-scheme="dark"]': { '--brand-text': '#cdb4fb' },
    body: {
      minHeight: '100vh',
      backgroundColor: theme.vars.palette.background.body,
      backgroundImage: 'radial-gradient(1000px 500px at 100% 0%, rgba(112,19,245,0.045), transparent 70%)',
      backgroundAttachment: 'fixed',
    },
    '[data-joy-color-scheme="dark"] body': {
      backgroundImage: 'radial-gradient(1000px 500px at 100% 0%, rgba(112,19,245,0.09), transparent 70%)',
    },
    '.MuiCard-root.MuiCard-root:not(.MuiCard-variantSolid):not(.MuiCard-variantSoft)': {
      backgroundColor: theme.vars.palette.background.surface,
      border: '1px solid', borderColor: theme.vars.palette.divider,
      borderRadius: '16px', boxShadow: '0 2px 8px rgba(16,24,40,0.035)',
    },
    '.MuiModalDialog-root.MuiModalDialog-root': {
      backgroundColor: theme.vars.palette.background.surface,
      border: '1px solid', borderColor: theme.vars.palette.divider,
      borderRadius: '20px', boxShadow: theme.vars.shadow.xl,
      maxHeight: 'calc(100dvh - 24px)', overflowY: 'auto',
    },
    '.MuiMenu-listbox, .MuiMenu-root, .MuiSelect-listbox': {
      backgroundColor: theme.vars.palette.background.surface,
      border: '1px solid', borderColor: theme.vars.palette.divider,
      borderRadius: '12px', boxShadow: theme.vars.shadow.md,
      maxWidth: 'calc(100vw - 24px)',
    },
    '.MuiTabList-root.MuiTabList-root:not([aria-orientation="vertical"])': {
      gap: '4px', padding: '4px', borderRadius: '12px', maxWidth: '100%',
      flexWrap: 'wrap', backgroundColor: theme.vars.palette.background.level1,
      border: '1px solid', borderColor: theme.vars.palette.divider,
    },
    '.MuiTabList-root.MuiTabList-root:not([aria-orientation="vertical"])::before': { display: 'none' },
    '.MuiTab-root.MuiTab-root': { borderRadius: '8px', fontWeight: 600, border: 'none', minHeight: '36px' },
    '.MuiTab-root.MuiTab-root::after': { display: 'none' },
    '.MuiTab-root.MuiTab-root[aria-selected="true"]': {
      backgroundColor: theme.vars.palette.background.surface,
      color: theme.vars.palette.primary.plainColor,
      boxShadow: '0 1px 4px rgba(16,24,40,0.10)',
    },
    '.MuiTabs-root.MuiTabs-root': { backgroundColor: 'transparent' },
    '.MuiChip-root.MuiChip-root': { borderRadius: '999px' },
    '.MuiSheet-root.MuiSheet-root': { borderRadius: '12px' },
    '[data-app-shell] .MuiTypography-h1': {
      fontSize: 'clamp(1.5rem, 2.2vw, 2rem)', lineHeight: 1.25, letterSpacing: '-0.035em',
      overflowWrap: 'anywhere',
    },
    '[data-app-shell] :is(button, a, input, textarea, select, [tabindex]):focus-visible': {
      outline: '3px solid', outlineColor: theme.vars.palette.primary.outlinedBorder,
      outlineOffset: '3px',
    },
    '[data-app-shell] .MuiInput-root, [data-app-shell] .MuiTextarea-root, [data-app-shell] .MuiSelect-root': {
      boxShadow: 'none',
    },
    '[data-app-shell] main': { scrollMarginTop: '100px' },
    '@media (max-width: 599px)': {
      '.MuiModalDialog-root.MuiModalDialog-root': { maxWidth: 'calc(100vw - 24px)' },
    },
    '@media (prefers-reduced-motion: reduce)': {
      '*, *::before, *::after': { scrollBehavior: 'auto !important', transitionDuration: '0.01ms !important', animationDuration: '0.01ms !important', animationIterationCount: '1 !important' },
    },
  })} />;
}
